import styled from 'styled-components'

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const FieldWrapper = styled.div`
  min-height: 230px;
`

export const Footer = styled.div`
  ${({ theme }) => `
    text-align: center;

    button {
      margin: 0px ${theme.space.xxs};
    }
  `}
`
